/*
 * Copyright (c) 2020 Staffino, s.r.o. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Martin Komara, April 2020
 */

import React from 'react';
import { FlowBlockRow as BlockModel } from '@staffino/model';
import { Box } from '@staffino/primitive-controls';
import BlockFactory from './block-factory';

type Props = {
  block: BlockModel;
};

const RowBlock = ({ block: { children = [] } }: Props) => (
  <Box
    flexDirection={'row' as const}
    justifyContent="center"
    alignItems="center"
    textAlign="center"
  >
    {children.map((child) => (
      <BlockFactory key={child.id} block={child} />
    ))}
  </Box>
);

export default RowBlock;
